module.exports = __webpack_public_path__ + "assets/font/MECHABREAKregular-1.08-306277f4.ttf";